import {
	REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS,
	RECEIVE_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS,
	RECEIVE_BAD_REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS
} from "./index";


export function requestGetApplicationAcceptedStatusesTransitions(){
	return {
		type: REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS
	}
}

export function receiveApplicationAcceptedStatusesTransitions(payload){
	return {
		type: RECEIVE_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS,
		payload
	}
}

export function receiveBadRequestApplicationAcceptedStatusesTransitions(payload){
	return {
		type: RECEIVE_BAD_REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS,
		payload
	}
}
